import { createContext, useContext } from 'react';
import { isExperimentEnabled } from '../services/is-experiment-enabled';
export const ExperimentsContext = createContext(undefined);
export const useExperiments = ()=>{
    const experiments = useContext(ExperimentsContext) || {};
    return {
        experiments,
        isExperimentEnabled: (spec)=>isExperimentEnabled(experiments, spec)
    };
};

//# sourceMappingURL=experiments-context.js.map